pageId = 'reports-questions-index'

$(document).on "pjaxload##{pageId }", (e, $page, page) ->
  $('.link-destroy-question').on 'click', tower.questionDestroy

  $('.reports-questions-list').sortable
    handle: '.question-link'
    scrollSensitivity: 20
    cursor: 'move'
    distance: 5
    helper: 'clone'
    items: '.question'
    placeholder: 'question-placeholder'
    tolerance: 'pointer'
    update: (e, ui) ->
      $question = ui.item
      $.ajax
        url: $question.data('url')
        type: 'post'
        data:
          prev_question_guid: $question.prev().data('guid')
          next_question_guid: $question.next().data('guid')
        success: ->
          tower.highlight $question
          return false
